import { connect } from 'react-redux'
import Config from 'config'
import { SETTINGSCREENS } from 'macguffin/redux/constants'
import { openSettingsScreen, toggleMute, } from 'macguffin/redux/actions'
import { uiButtonPressed, setPopupScreen } from '../../redux/actions'
import { BUTTON_CLOSE, TOGGLE_MUTE } from '../../redux/constants'
import SvgIcon from '../svg/SvgIcon'
import SoundButton from '../controls/SoundButton'

const { INFO, SETTINGS } = SETTINGSCREENS

const SettingsMenu = props => {
  const {
    base: {
      settingScreen,
      muted,
      soundAvailable,
      loadingSounds,
      soundsLoaded,
    },
    openSettingsScreen,
    toggleMute,
    uiButtonPressed,
    setPopupScreen,
    svgIcons,
  } = props
  const quickspinEnabled = Config.FEATURE_CONFIG.QUICKSPIN

  const openSetting = setting => {
    return () => {
      setPopupScreen(null)
      openSettingsScreen(setting)
      uiButtonPressed(setting || BUTTON_CLOSE)
    }
  }
  const onSoundButton = () => {
    toggleMute()
    uiButtonPressed(TOGGLE_MUTE)
  }

  const soundButtonProps = {
    muted,
    available: soundAvailable,
    loading: loadingSounds,
    loaded: soundsLoaded,
    onClick: onSoundButton,
    svgIcons,
  }

  return (
    <div className={`settings-menu${quickspinEnabled ? '' : ' no-quickspin'}`}>
      <div className={`menu-item ${settingScreen === INFO ? 'active' : ''}`}>
        <SvgIcon
          svgIcons={svgIcons}
          iconName='info'
          onClick={openSetting(INFO)}
          eventsOnContainer={true}
        />
      </div>
      <div className={`menu-item ${settingScreen === SETTINGS ? 'active' : ''}`}>
        <SvgIcon
          svgIcons={svgIcons}
          iconName='settings'
          onClick={openSetting(SETTINGS)}
          eventsOnContainer={true}
        />
      </div>
      {soundAvailable && <SoundButton {...soundButtonProps} />}
    </div>
  )
}

export default connect(state => ({
  base: state.base,
  dimensions: state.UI.dimensions,
  popupScreen: state.UI.popupScreen,
  betAmount: state.session.betAmount,
}), { setPopupScreen, openSettingsScreen, uiButtonPressed, toggleMute })(SettingsMenu)